import React from 'react';
import classNames from 'classnames';

import css from './IconWifi.module.css';

/**
 * IconWifi icon.
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own css.root
 * @param {string?} props.rootClassName overwrite components own css.root
 * @returns {JSX.Element} SVG icon
 */
const IconWifi = props => {
  const { rootClassName, className } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg
      className={classes} width="22" height="22" viewBox="0 0 32 32" fill="none"  xmlns="http://www.w3.org/2000/svg">
      <path d="M11.9997 2.41699C7.5418 2.41699 3.96364 3.96441 1.27096 6.07355C0.60926 6.5918 0.476128 7.51095 0.882505 8.2221L1.56409 9.41485C2.11566 10.3801 3.39303 10.5749 4.27227 9.9518C6.3453 8.48265 8.98885 7.298 11.9997 7.298C15.0105 7.298 17.6539 8.48265 19.7269 9.9518C20.6062 10.5749 21.8836 10.3801 22.4352 9.41485L23.1168 8.2221C23.5231 7.51095 23.3899 6.5918 22.7283 6.07355C20.0356 3.96441 16.4575 2.41699 11.9997 2.41699Z" fill="#262338"/>
<path d="M11.9786 17.2021C10.631 17.2021 9.53886 18.2948 9.53906 19.6426C9.53926 20.9904 10.6318 22.0831 11.9794 22.0831C13.327 22.0831 14.4191 20.9904 14.4189 19.6426C14.4187 18.2948 13.3262 17.2021 11.9786 17.2021Z" fill="#262338"/>
<path d="M11.9988 10.083C9.24657 10.083 7.33907 10.8453 5.74862 12.0495C5.04392 12.583 4.95487 13.5632 5.42592 14.2698L6.09337 15.2709C6.61172 16.0484 7.67597 16.143 8.42052 15.6824C9.35343 15.1054 10.5914 14.6111 11.9988 14.6111C13.4062 14.6111 14.6442 15.1054 15.5771 15.6824C16.3216 16.143 17.3859 16.0484 17.9043 15.2709L18.5717 14.2698C19.0428 13.5632 18.9537 12.583 18.249 12.0495C16.6585 10.8453 14.7511 10.083 11.9988 10.083Z" fill="#262338"/>
    </svg>
  );
};

export default IconWifi;
